console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_CSMEET
const BASEURL_API = process.env.VUE_APP_APIURL_API

// import scheduleMatchList from './mock/compreSportsMeet/schedule_match_list'
// import selectDateSportsList from './mock/compreSportsMeet/select_dateSportsList'
// import delegationList from './mock/compreSportsMeet/delegationList'
// import delegationDetail_medalList from './mock/compreSportsMeet/delegationDetail_medalList'

// 综合性运动会 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  let baseUrl = ''
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  return baseUrl + baseApi
}

// 获取赛季 接口
export const https_seasonList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/sc/season/list/${params.cid}`))
}

// 奖牌榜 接口
export const https_medalTally_list = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/medal/list/${params.cid}/${params.sid}?disciplineCode=${params.sportsId}&orgCode=${params.delegationId}`
    )
  )
}

// 奖牌明细 日期查询 接口
export const https_medalDetail_dateSports = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/medal/date/list/${params.cid}/${params.sid}/${params.timeZone}`
    )
  )
}

// 奖牌明细 接口
export const https_medalDetail_list = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/medal/detail/list/${params.cid}/${params.sid}?date=${params.date}&disciplineCode=${params.disciplineCode}&orgCode=${params.orgCode}`
    )
  )
}

// 最外层 常规赛程列表 接口
export const https_schedule_matchList = (baseUrl, axios, params) => {
  console.debug(params)
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sc/schedule/list/${params.sid}/${params.date}/${params.timeZone}?disciplineCode=${params.sportsId}&orgCode=${params.delegationId}&name=${params.name}&pnum=${params.pnum}&psize=${params.psize}`
    )
  )
  // return axios.mock(scheduleMatchList)
}

// 最外层 运动员赛程列表 接口
export const https_playersSchedule_matchList = (baseUrl, axios, params) => {
  console.debug(params)
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/event/phasecompetitorathlete/${params.cid}/${params.sid}/${params.timeZone}?startDate=${params.date}&disciplineCode=${params.sportsId}&orgCode=${params.delegationId}`
    )
  )
  // return axios.mock(scheduleMatchList)
}

// 最外层 项目阶段列表 接口
export const https_eventPhase_list = (baseUrl, axios, params) => {
  console.debug(params)
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/event/phase/${params.cid}/${params.sid}/${params.timeZone}?disciplineCode=${params.sportsId}&eventCode=${params.eventId}`
    )
  )
  // return axios.mock(scheduleMatchList)
}

// 日期和大项 选择框 接口
export const https_select_dateBigSports = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/sc/date/menu/${params.sid}/${params.timeZone}`)
  )
  // return axios.mock(selectDateSportsList)
}

// 代表团 选择框 接口
export const https_select_delegationList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/sc/org/menu/${params.sid}`))
}

// 代表团 列表 接口
export const https_delegationList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/org/list/${params.sid}?name=${params.name}`)
  )
}

// 单个代表团 头部详情 接口
export const https_delegationDetailInfor = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/org/main/stat/${params.sid}/${params.delegationId}`
    )
  )
}

// 代表团 日期和大项 选择框 接口
export const https_delegation_select_dateBigSports = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/org/schedule/menu/${params.sid}/${params.delegationId}/${params.timeZone}`
    )
  )
}

// 代表团详情 赛程 接口
export const https_delegationDetail_schedule = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sc/schedule/org/${params.sid}/${params.delegationId}/${params.date}/${params.timeZone}?disciplineCode=${params.sportsId}`
    )
  )
}

// 代表团详情 参赛名单 接口
export const https_delegationDetail_players = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/org/athlete/list/${params.sid}/${params.delegationId}`
    )
  )
}

// 代表团详情 获奖明细 接口
export const https_delegationDetail_medalList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/org/medal/list/${params.sid}/${params.delegationId}`
    )
  )
  // return axios.mock(delegationDetail_medalList)
}

// 项目 大项列表 接口
export const https_sportsList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/sp/sport/list/${params.sid}`))
}

// 项目 大小项列表 接口
export const https_sportsList_eventList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/sp/event/menu/${params.sid}`))
}

// 项目 小项运动员列表 接口
export const https_sportsEvent_playerList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/event/athlete/${params.sid}/${params.eventId}`
    )
  )
}

// 项目 小项奖牌榜 接口
export const https_sportsEvent_medalList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/event/medal/${params.cid}/${params.sid}/${params.eventId}?name=${params.name}`
    )
  )
}
// 项目 赛程 接口
export const https_sportsEvent_schedule = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sc/schedule/event/${params.sid}/${params.sportsId}/${params.eventId}/${params.timeZone}`
    )
  )
}

// 项目 综合成绩 接口
export const https_sportsEvent_compreScore = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sp/event/comprehensive/${params.cid}/${params.sid}/${params.sportsId}/${params.eventId}/${params.timeZone}`
    )
  )
}

// 赛程详情 - 比赛数据 实时 接口（项目中暂时废弃）
export const https_scheduleDetail_matchBaseInfor = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sc/schedule/single/${params.sid}/${params.mid}/${params.timeZone}`
    )
  )
}

// 赛程详情 - 赛果数据 实时 【基本信息 || 出场名单 || 本场数据 】
export const https_scheduleDetail_matchDetailData = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/result/${params.sportsId}?seasonCode=${params.sid}&scheduleCode=${params.mid}`
    )
  )
}

// 赛程详情 - 赛果数据 数据战报
export const https_scheduleDetail_dataBattleReport = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/reportData/getReportWords`),
    params
  )
}

// 运动员 列表 接口
export const https_playerList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/at/athlete/list/${params.sid}/${params.delegationId}/${params.sportsId}?name=${params.name}`
    )
  )
}

// 运动员-详情 接口
export const https_playerDetail = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/at/athlete/detail/${params.sid}/${params.playerId}`
    )
  )
}

// 纪录-纪录类型 select 接口
export const https_select_recordTypeList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/rc/record/type/list/${params.sid}`)
  )
}

// 纪录-大项 select 接口; 根据纪录类型得到大项数组
export const https_select_recordTypeGetSportsList = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/rc/record/sports/${params.sid}/${params.recordType}`
    )
  )
}

// 记录-新项目列表 接口
export const https_record_newSportsList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/rc/record/sports/${params.sid}`))
}

// 记录-新记录类型接口
export const https_record_newRecordType = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/rc/record/type/list/${params.sid}?disciplineCode=${params.dCode}`
    )
  )
}

// 纪录 列表 接口
export const https_recordList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/rc/record/list/${params.sid}/${params.sportsId}/${params.recordType}/${params.timeZone}`
    )
  )
}

// 场馆信息 列表 接口
export const https_venueList = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/vu/venue/list/${params.sid}`))
}

// 所有比赛 大项|小项|日期|比赛 4级 接口
export const https_allMatchList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/sc/schedule/broadcast/all/${params.sid}`)
  )
}

// 编辑奖牌榜 排名 接口
export const https_editMedalTally = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/sp/event/editEventMedal`),
    params
  )
}

// 赛果通过比赛id，查赛段和该赛段下的子比赛 接口
export const https_getPhaseSchedule = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/sc/schedule/getPhaseSchedule`),
    params
  )
}
